export default {
  traceability: {
    corporativeTitle: "Nome da Empresa",
    originTitle: "Título de Origem",
    coffeeInformation: "Informações sobre o Café",
    uploadImage: "Carregar Imagem",
    originationCountry: "País de Origem",
    traceabilityImage: "Imagem de Rastreabilidade",
    traceability: "Rastreabilidade",
    coffeeTraceabilityMngmnt: "Gestão de Rastreabilidade do Café",
    traceabilityPage: "Página de Rastreabilidade",
    labelDesigner: "Designer de Etiqueta",
    additionalInformation: "Informações Adicionais",
    info1:
      "Forneça informações sobre os logotipos adicionais do seu produto. Essas informações estarão disponíveis ao público na página de rastreabilidade do café.",
    addSlogan: "Adicionar Slogan",
    additionalLogos: "Logotipos Adicionais",
    title: "Título",
    description: "Descrição",
    mapLink: "Link do Mapa",
    websiteLink: "Link do Website",
    addMedia: "Adicionar Mídia",
    uploadImageVideo: "Carregar Imagem/Vídeo",
    origin: "Origem",
    info2:
      "Forneça informações sobre o país de origem do seu produto. Essas informações estarão disponíveis ao público na página de rastreabilidade do café.",
    countryImage: "Imagem do País",
    institutionalInfo: "Informações Institucionais",
    info3:
      "Forneça informações sobre a sua empresa/cooperativa, conte aos consumidores sobre o trabalho relevante que você tem realizado. Essas informações estarão disponíveis ao público na página de rastreabilidade do café.",
    cooperativeLogo: "Logotipo da Cooperativa",
    traceabilityIntro: "Introdução à Rastreabilidade",
    info4:
      "Esta seção dará ao consumidor acesso a todo o histórico de produção e processamento de café. Descreva a importância da rastreabilidade para a sua empresa/cooperativa e para o mundo.",
    addLabel: "Adicionar Etiqueta",
    chooseTitle: "Escolher Título",
    chooseLabelDesign: "Escolher Modelo de Design de Etiqueta",
    uploadYourLogo: "Carregar seu Logotipo",
    info5:
      "Instruções: O tamanho da imagem deve ser pelo menos 1000 x 1000 pixels quadrados. Você pode escolher o formato PNG transparente para combinar com as cores de fundo.",
    chooseTemplateColors: "Escolher Cores do Modelo",
    backgroundColor: "Cor de Fundo",
    foregroundColor: "Cor de Primeiro Plano",
    labelStatus: "Status da Etiqueta",
    inactive: "Inativo",
    download: "Baixar",
    enterLabelTitle: "Insira o Título da Etiqueta",
  },
  cacaoTraceability: {
    corporativeTile: "Etiqueta Corporativa",
    originTitle: "Título de Origem",
    traceability: "Rastreabilidade",
    cacaoTraceabilityMngmnt: "Gestão de Rastreabilidade do Cacau",
    traceabilityPage: "Página de Rastreabilidade",
    labelDesigner: "Designer de Etiqueta",
    additionalInformation: "Informações Adicionais",
    info1:
      "Forneça informações sobre os logotipos adicionais do seu produto. Essas informações estarão disponíveis ao público na página de rastreabilidade do cacau.",
    addSlogan: "Adicionar Slogan",
    additionalLogos: "Logotipos Adicionais",
    title: "Título",
    description: "Descrição",
    mapLink: "Link do Mapa",
    websiteLink: "Link do Website",
    addMedia: "Adicionar Mídia",
    uploadImageVideo: "Carregar Imagem/Vídeo",
    origin: "Origem",
    info2:
      "Forneça informações sobre o país de origem do seu produto. Essas informações estarão disponíveis ao público na página de rastreabilidade do cacau.",
    countryImage: "Imagem do País",
    institutionalInfo: "Informações Institucionais",
    info3:
      "Forneça informações sobre a sua empresa/cooperativa, conte aos consumidores sobre o trabalho relevante que você tem realizado. Essas informações estarão disponíveis ao público na página de rastreabilidade do cacau.",
    cooperativeLogo: "Logotipo da Cooperativa",
    traceabilityIntro: "Introdução à Rastreabilidade",
    info4:
      "Esta seção dará ao consumidor acesso a todo o histórico de produção e processamento de cacau. Descreva a importância da rastreabilidade para a sua empresa/cooperativa e para o mundo.",
    addLabel: "Adicionar Etiqueta",
    chooseTitle: "Escolher Título",
    chooseLabelDesign: "Escolher Modelo de Design de Etiqueta",
    uploadYourLogo: "Carregar seu Logotipo",
    info5:
      "Instruções: O tamanho da imagem deve ser pelo menos 1000 x 1000 pixels quadrados. Você pode escolher o formato PNG transparente para combinar com as cores de fundo.",
    chooseTemplateColors: "Escolher Cores do Modelo",
    backgroundColor: "Cor de Fundo",
    foregroundColor: "Cor de Primeiro Plano",
    labelStatus: "Status da Etiqueta",
    inactive: "Inativo",
    download: "Baixar",
    enterLabelTitle: "Insira o Título da Etiqueta",
  },
}

